/**
 * Creates a debounced function that delays invoking func until after wait milliseconds (delay) have elapsed since the last time
 * the debounced function was invoked. The func is invoked with the last arguments provided to the debounced function.
 *
 * @param func
 * @param delay
 * @returns {Function}
 */

export default (func, delay) => {
  let timeoutId
  return function() {
    const context = this
    const args = arguments
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func.apply(context, args), delay)
  }
}
